module.exports = __webpack_public_path__ + "static/santeboutiquemobile2-4043ae4e0b2bc983a9815096ecf8fb9d.jpg";